import { Flex } from "antd";
import React, { useEffect, useRef } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CRUISE_CATEGORY } from "../../../utils/helpers";
import Legends from "../v2/Legends";
import PromoTagRibbon from "../PromoTagRibbon";

dayjs.extend(customParseFormat);

const TourDateSelectorV3 = (props: {
  dates: any[];
  selectedDate: string;
  selectedTourCode: any;
  selectTour: Function;
  category: string;
  isNew?: boolean;
  isLoading?: boolean;
  open?: boolean;
}) => {
  const { dates, selectedDate, selectedTourCode, selectTour, category, isLoading, open } = props;
  const isCruise = category === CRUISE_CATEGORY;
  const hasAnyGD = !isCruise && dates.some(t => t.type === "guaranteed");
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // `open` is only meaningful for drawer usage (BookingFormV3) — skip only
    // when a drawer explicitly says it's closed. Inline usage (ShowPage) never
    // passes `open`, so it always scrolls the selected/resolved date into view.
    if (open === false || !scrollRef.current) return;
    const idx = dates.findIndex(t =>
      selectedDate ? (t.date === selectedDate && t.code === selectedTourCode) : t.code === selectedTourCode
    );
    const el = scrollRef.current.children[idx] as HTMLElement | undefined;
    if (el) el.scrollIntoView({ behavior: "auto", inline: "start", block: "nearest" });
  }, [open, selectedTourCode, selectedDate, dates.length]);

  return (
    <Flex gap={15} vertical className="tour-date-selector v3">
      {/* Native CSS scroll-snap row — no react-slick (avoids fractional-slidesToShow ghost-scroll) */}
      <div className={`wrapper${isLoading ? " is-loading" : ""}`} ref={scrollRef}>
        {dates.map((tour: { id?: number; date: string; code: string; type: string; price: string; indicator: string; promoTag?: string }) => {
            const tourDate = dayjs(tour.date, "DD/MM/YYYY").toDate();
            const tourYear = tourDate.getFullYear();
            const tourDateFormatted = dayjs(tourDate).format("DD MMM");
            const selected = selectedDate
              ? selectedDate === tour.date && selectedTourCode === tour.code
              : selectedTourCode === tour.code;

            return (
              <div key={tour.code} className={`tour-date-box-wrapper${tour.promoTag ? " has-promo" : ""}`} onClick={() => selectTour(tour)}>
                {hasAnyGD && (
                  <div
                    className="tour-date-box_gd-badge"
                    style={tour.type !== "guaranteed" ? { visibility: "hidden" } : undefined}
                  >
                    Guaranteed Departure
                  </div>
                )}
                <div className={`tour-date-box ${!isCruise ? tour.type : ""} ${selected ? "selected" : ""}`}>
                  <Flex justify="space-between" align="center" vertical gap={8}>
                    <div className="tour-date-box_date">
                      <span>{tourYear}</span>
                      <b>{tourDateFormatted}</b>
                    </div>
                    <div>
                      <span>From</span>
                      <div className="tour-date-box_price">{tour.price}</div>
                    </div>
                  </Flex>
                  {tour.promoTag && <PromoTagRibbon label={tour.promoTag} />}
                </div>
              </div>
            );
          })}
      </div>

      {!isCruise && <Legends />}
    </Flex>
  );
};

export default TourDateSelectorV3;
